import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-md-6 mb-4" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-md-6 mb-4" }
const _hoisted_6 = { class: "box" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_customer_purchases = _resolveComponent("customer-purchases")!
  const _component_customer_survey_answers = _resolveComponent("customer-survey-answers")!

  return (_ctx.user)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _cache[0] || (_cache[0] = _createElementVNode("hr", null, null, -1)),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_customer_purchases, { user: _ctx.user }, null, 8, ["user"])
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_customer_survey_answers, { user: _ctx.user }, null, 8, ["user"])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}